export const refreshTableEmployeeToggle = (value: boolean) => {
    return {
        payload: value,
        type: 'REFRESH_TABLE_EMPLOYEE_TOGGLE'
    };
}